import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M7.31 18.649a.5.5 0 0 0 .006.707q.37.366.732.702a.5.5 0 1 0 .681-.732q-.35-.327-.712-.682a.5.5 0 0 0-.707.005m1.694 1.606a.5.5 0 0 0 .06.704q.405.341.797.642a.5.5 0 1 0 .609-.794q-.375-.286-.761-.613a.5.5 0 0 0-.705.06m1.984 2.143q.457.296.896.53a.5.5 0 1 0 .471-.881 12 12 0 0 1-.825-.489.5.5 0 1 0-.542.84m3.245 1.373a6 6 0 0 1-1.053-.269.5.5 0 0 1 .326-.945q.46.159.884.226a.5.5 0 0 1-.157.988m1.522.002a6 6 0 0 0 1.054-.267.5.5 0 1 0-.325-.946 5 5 0 0 1-.884.225.5.5 0 1 0 .155.988m3.267-1.381q-.457.296-.895.53a.5.5 0 0 1-.473-.88q.402-.216.825-.49a.5.5 0 0 1 .543.84m1.115-.79q.392-.3.797-.642a.5.5 0 0 0-.645-.764q-.387.326-.76.612a.5.5 0 0 0 .608.794m2.54-2.24q-.36.356-.712.684a.5.5 0 0 1-.681-.732q.34-.318.692-.664a.5.5 0 1 1 .702.712",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E87E04",
      fillRule: "evenodd",
      d: "M11.948 18.333s.266-1.177-1.113-.981c-.35.049-.673.213-1 .189-.451-.034-.847-.338-1.219-.508-.424-.193-.808-.264-1.048-.483-.26-.235-.401-.644-.614-1.025-.132-.236-.583-.309-.583-1.113 0-.805-.473-1.43-.35-1.668.209-.41.882 1.758 2.111-.228.58-.937 1.129-.922 2.703-.347 1.575.575.968-2.75.968-2.75s3.608 1.053 5.456.677c.449-.092 1.734-.126 2.403-.677.548 0 1.445 0 2.72-.804.45-.284.607-.356 1-.788.674 0 1.288-.375 1.479-.524.958-.746 1.12-.41 1.376-.529.418-.194.699-.44.699-.44s.412.498-.851.869c-.466.137-.578.577-.979.866-.684.493-1.598.92-2.117 1.35-.737.611-.675 1.01-.948.955-.806-.164-.981.393-1.14.788-.544 1.354 2.03 2.457 1.481 2.978-1.935-.569-1.739.538-2.172.178-.778-.648-1.752-.19-1.752.366 0 1.165-.528.985-1.337 1.286-1.03.383-1.464.86-1.92.86-1.404 0-1.81.192-2.325.522-.481.308.12.981.12.981z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagCyp = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagCyp_default = SvgFlagCyp;

export { FlagCyp_default as default };
